export default __webpack_public_path__ + "static/media/$pac.16d59c29.svg";